import request from '@/utils/server'
// 获取
  export function getCheckData(query) {
    return request({
      url: '/monitor/getMonitorList',    
      method: 'get',
      params: query
    })
  }
  // 新增
  export function add(data) {
    return request({
      url: '/monitor/add',
      
      method: 'POST',
      data: data
    })
  }
//   修改
export function edit(data) {
    return request({
      url: '/monitor/edit',
      method: 'POST',
      data: data
    })
  }

  // 删除
  export function delmonitor(data) {
    return request({
      url: '/monitor/delete',
      method: 'POST',
      data: data
    })
  }